export const XIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.075 9.475L3.175 14.375C2.99167 14.5583 2.75833 14.65 2.475 14.65C2.19167 14.65 1.95833 14.5583 1.775 14.375C1.59167 14.1917 1.5 13.9583 1.5 13.675C1.5 13.3917 1.59167 13.1583 1.775 12.975L6.675 8.075L1.775 3.175C1.59167 2.99167 1.5 2.75833 1.5 2.475C1.5 2.19167 1.59167 1.95833 1.775 1.775C1.95833 1.59167 2.19167 1.5 2.475 1.5C2.75833 1.5 2.99167 1.59167 3.175 1.775L8.075 6.675L12.975 1.775C13.1583 1.59167 13.3917 1.5 13.675 1.5C13.9583 1.5 14.1917 1.59167 14.375 1.775C14.5583 1.95833 14.65 2.19167 14.65 2.475C14.65 2.75833 14.5583 2.99167 14.375 3.175L9.475 8.075L14.375 12.975C14.5583 13.1583 14.65 13.3917 14.65 13.675C14.65 13.9583 14.5583 14.1917 14.375 14.375C14.1917 14.5583 13.9583 14.65 13.675 14.65C13.3917 14.65 13.1583 14.5583 12.975 14.375L8.075 9.475Z"
        fill="#060606"
        fillOpacity="0.6"
        stroke="#828282"
        strokeWidth="3"
      />
    </svg>
  );
};
